import React, { useRef } from "react";
import EmptyProfilePicture from "../../../../../../../assets/blank-profile-picture.png";
import ImageNotAvailable from "../../../../../../../assets/instagram_image.png";
// import { ReactComponent as ViewIcon } from "../../../../../../../assets/svg/comp-view-icon.svg";
import { ReactComponent as EngageIcon } from "../../../../../../../assets/svg/engage-icon.svg";
// import { ReactComponent as LikeIcon } from "../../../../../../../assets/svg/comp-like-icon.svg";
// import { ReactComponent as CommentIcon } from "../../../../../../../assets/svg/comp-comment-icon.svg";
// import { ReactComponent as ShareIcon } from "../../../../../../../assets/svg/comp-share-icon.svg";
import { ReactComponent as IgCommentIcon } from "../../../../../../../assets/svg/insta-comment-icon.svg";
import { ReactComponent as FbCommentIcon } from "../../../../../../../assets/svg/facebook-comment-icon.svg";
import { ReactComponent as IgLikeIcon } from "../../../../../../../assets/svg/insta-like-icon.svg";
import { ReactComponent as FbLikeIcon } from "../../../../../../../assets/svg/facebook-like-icon.svg";
import { ReactComponent as IgShareIcon } from "../../../../../../../assets/svg/insta-share-icon.svg";
import { ReactComponent as FbShareIcon } from "../../../../../../../assets/svg/facebook-share-icon.svg";
import { ReactComponent as ImpactIcon } from "../../../../../../../assets/svg/impact.svg";
import { ReactComponent as ViewsIcon } from "../../../../../../../assets/svg/views.svg";
import { ReactComponent as ExitIcon } from "../../../../../../../assets/svg/ig-story-exit.svg";
import { ReactComponent as ImpressionIcon } from "../../../../../../../assets/svg/impressions.svg";
import { ReactComponent as ChevronIcon } from "../../../../../../../assets/svg/chevron.svg";
import "./RecentPosts.scss";
import { Icon, Popup } from "semantic-ui-react";
import { kmFormatter } from "../../../../../Dashboard/Charts/utils";

function RecentPost(props) {
    let data = props?.data;

    const profileImage = useRef();
    const postImage = useRef();

    const handleProfileImageError = () => {
        profileImage.current.src = EmptyProfilePicture;
    };

    const handlePostImageError = () => {
        postImage.current.src = ImageNotAvailable;
    };

    const truncate = (str = "", max = 22) => {
        const ellipsis = str?.length > max ? "..." : "";
        return str?.slice(0, max) + ellipsis;
    };

    const getContent = (str1, str2) => {
        if (str1) return truncate(str1, 80);
        else if (str2) return truncate(str2, 80);
        else return "";
    };

    return (
        <div className="twitterPostContainer">
            <div className="header">
                <img
                    className="header_picture"
                    src={!data?.profile_pic || data?.profile_pic.includes("null") ? EmptyProfilePicture : data?.profile_pic}
                    onError={() => handleProfileImageError()}
                    ref={profileImage}
                    alt="empty"
                />
                <div className="header_name">
                    <Popup
                        className="skiptranslate"
                        position="top left"
                        size="mini"
                        inverted
                        content={data?.username}
                        trigger={<p className="full_name">{truncate(data?.username)}</p>}
                        style={{ zIndex: "99999" }}
                    />
                    <Popup
                        trigger={<p className="user_name">{data?.created_date}</p>}
                        content={data?.hover_date}
                        inverted
                        className="skiptranslate"
                        size="mini"
                        position="top center"
                    />
                </div>
            </div>
            <div className="post">
                <div className="content">{getContent(data?.content, data?.title)}</div>
                <div className="postImage">
                    {data?.post_type === "IMAGE" && (
                        <img
                            src={!data?.image_url || data?.image_url.includes("null") ? ImageNotAvailable : data?.image_url}
                            alt="post"
                            onError={() => handlePostImageError()}
                            ref={postImage}
                        />
                    )}
                    {data?.post_type === "VIDEO" && (
                        <>
                            <img
                                src={!data?.image_url || data?.image_url.includes("null") ? ImageNotAvailable : data?.image_url}
                                alt="post"
                                onError={() => handlePostImageError()}
                                ref={postImage}
                            />
                            <a target="_blank" href={data?.post_url} rel="noreferrer">
                                <Icon name="video play" size="huge" className="video-play" crossOrigin="" />
                            </a>
                        </>
                    )}
                </div>
            </div>

            <div className="footer">
                <Popup
                    className="twitterPopup"
                    content="Comments"
                    trigger={
                        <div className="iconContainer">
                            <div className="twitterIcon">{props.platform === "instagram" ? <IgCommentIcon /> : <FbCommentIcon />}</div>
                            <p>{kmFormatter(data?.engagement?.comment_count)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />
                <Popup
                    className="twitterPopup"
                    content="Likes"
                    trigger={
                        <div className="iconContainer">
                            <div className="twitterIcon">{props.platform === "instagram" ? <IgLikeIcon /> : <FbLikeIcon />}</div>
                            <p>{kmFormatter(data?.engagement?.like_count)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />

                {props.platform === "facebook" && (
                    <Popup
                        className="twitterPopup"
                        content="Shares"
                        trigger={
                            <div className="iconContainer">
                                <div className="twitterIcon">{props.platform === "instagram" ? <IgShareIcon /> : <FbShareIcon />}</div>
                                <p>{kmFormatter(data?.engagement?.share_count)}</p>
                            </div>
                        }
                        size="mini"
                        position="top left"
                        inverted
                    />
                )}
                {props.platform === "instagram" && data.post_subtype === "story" && (
                    <Popup
                        className="twitterPopup"
                        content="Impression"
                        trigger={
                            <div className="iconContainer">
                                <div className="twitterIcon">
                                    <ImpressionIcon className="impressionicon" />
                                </div>
                                <p>{kmFormatter(data?.engagement?.impressions_count)}</p>
                            </div>
                        }
                        size="mini"
                        position="top left"
                        inverted
                    />
                )}
                {props.platform === "instagram" && data.post_subtype === "story" && (
                    <Popup
                        className="twitterPopup"
                        content="Taps Forward"
                        trigger={
                            <div className="iconContainer">
                                <div className="twitterIcon">
                                    <ChevronIcon className="chevron" />
                                </div>
                                <p>{kmFormatter(data?.engagement?.taps_forward_count)}</p>
                            </div>
                        }
                        size="mini"
                        position="top left"
                        inverted
                    />
                )}
                {props.platform === "instagram" && data.post_subtype === "story" && (
                    <Popup
                        className="twitterPopup"
                        content="Taps Backward"
                        trigger={
                            <div className="iconContainer">
                                <div className="twitterIcon">
                                    <ChevronIcon className="chevron tapBack" />
                                </div>
                                <p>{kmFormatter(data?.engagement?.taps_back_count)}</p>
                            </div>
                        }
                        size="mini"
                        position="top left"
                        inverted
                    />
                )}
                {props.platform === "instagram" && data.post_subtype === "story" && (
                    <Popup
                        className="twitterPopup"
                        content="Exit Count"
                        trigger={
                            <div className="iconContainer">
                                <div className="twitterIcon">
                                    <ExitIcon />
                                </div>
                                <p>{kmFormatter(data?.engagement?.exits_count)}</p>
                            </div>
                        }
                        size="mini"
                        position="top left"
                        inverted
                    />
                )}
                {/* {props.platform === "instagram" && (
                    <Popup
                        className="twitterPopup"
                        content="Views"
                        trigger={
                            <div className="iconContainer">
                                <div className="twitterIcon">
                                    <ViewsIcon />
                                </div>
                                <p>{kmFormatter(data?.engagement?.view_count)}</p>
                            </div>
                        }
                        size="mini"
                        position="top left"
                        inverted
                    />
                )} */}
                {(props.platform !== "instagram" || (props.platform === "instagram" && data.post_subtype !== "story")) && (
                    <Popup
                        className="twitterPopup"
                        content="Engagement"
                        trigger={
                            <div className="iconContainer">
                                <div className="twitterIcon">
                                    <EngageIcon />
                                </div>
                                <p>{kmFormatter(data?.totalEngagement)}</p>
                            </div>
                        }
                        size="mini"
                        position="top left"
                        inverted
                    />
                )}
                {(props.platform !== "instagram" || (props.platform === "instagram" && data.post_subtype !== "story")) && (
                    <Popup
                        className="twitterPopup"
                        content="Impact Value"
                        trigger={
                            <div className="iconContainer">
                                <div className="twitterIcon">
                                    <ImpactIcon className="impact-icon" />
                                </div>
                                <p>{kmFormatter(data?.impact)}</p>
                            </div>
                        }
                        size="mini"
                        position="top left"
                        inverted
                    />
                )}
                {(props.platform !== "instagram" || (props.platform === "instagram" && data.post_subtype !== "story")) && (
                    <Popup
                        className="twitterPopup"
                        content="View post"
                        trigger={
                            <div className="iconContainer twitterLinkIcon">
                                <a href={data?.post_url} target="_blank" rel="noreferrer">
                                    <Icon className="twitterIcon linkIcon" name="linkify" size="mid" color="#1DA1F2" />
                                </a>
                            </div>
                        }
                        size="mini"
                        position="top left"
                        inverted
                    />
                )}
            </div>
        </div>
    );
}

export default RecentPost;
